import Button from '@atlaskit/button/new';
import { Box, Inline, Pressable, xcss } from '@atlaskit/primitives';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { useCallback, useState } from 'react';
import { FilterPicker } from '../FilterPicker';
import { useIsMobile } from '../useIsMobile';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const clearFiltersButtonTextStyles = xcss({
  color: 'color.text.brand'
});
const buttonStyles = xcss({
  cursor: 'pointer',
  paddingBlock: 'space.050',
  paddingInlineStart: 'space.150',
  paddingInlineEnd: 'space.150',
  textAlign: 'center',
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'center',
  borderRadius: "var(--ds-space-250, 20px)",
  lineHeight: '1.5rem',
  color: 'color.text',
  backgroundColor: 'elevation.surface',
  fontSize: '0.875rem',
  fontWeight: '400',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  }
});
export const DesktopFilters = _ref => {
  let {
    filterDefinitions,
    filterOptions,
    filterStatus = {},
    onClearFilter: _onClearFilter,
    onClearAllFilters,
    onShowAllFilters,
    onSelectedOptionsChange,
    selectedOptions = {},
    showAllFilters
  } = _ref;
  const isMobile = useIsMobile();
  const [isAnyFilterOpen, setIsAnyFilterOpen] = useState(false);
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const isMpacWebCoherenceEnabled = enableMpacWebCoherence();
  const visibleFilters = showAllFilters ? filterDefinitions : filterDefinitions.filter(_ref2 => {
    let {
      hiddenByDefault
    } = _ref2;
    return !hiddenByDefault;
  });
  const hasHiddenFilters = filterDefinitions.length > visibleFilters.length;
  const hasSelectedFilters = Object.keys(selectedOptions).some(filterId => {
    var _selectedOptions$filt;
    return (_selectedOptions$filt = selectedOptions[filterId]) === null || _selectedOptions$filt === void 0 ? void 0 : _selectedOptions$filt.length;
  });
  const handleClearAllFilters = () => {
    onClearAllFilters === null || onClearAllFilters === void 0 ? void 0 : onClearAllFilters({
      location: 'desktop'
    });
    setIsAnyFilterOpen(false);
  };
  const onPopupToggle = useCallback(isOpen => {
    if (isOpen) {
      setIsAnyFilterOpen(true);
    }
  }, [setIsAnyFilterOpen]);

  // isAnyFilterOpen -> false; when clear all filters is clicked
  // Close any open filter popup when clear all filters is clicked
  // else don't do anything
  const filterPopupState = !isAnyFilterOpen ? false : undefined;
  return /*#__PURE__*/_jsxs(Inline, {
    space: "space.100",
    rowSpace: "space.100",
    shouldWrap: true,
    children: [visibleFilters.map(_ref3 => {
      let {
        filterId,
        label,
        isMulti,
        isSearchable,
        hasClearSelectionButton,
        groupSelectedItems
      } = _ref3;
      return /*#__PURE__*/_jsx(FilterPicker, {
        label: label,
        isMulti: isMulti,
        isPopupOpen: isMobile ? false : filterPopupState,
        isSearchable: isSearchable,
        hasClearSelectionButton: hasClearSelectionButton,
        onPopupToggle: onPopupToggle,
        onChange: options => onSelectedOptionsChange({
          filterId,
          options,
          location: 'desktop'
        }),
        onClearFilter: () => _onClearFilter(filterId),
        options: filterOptions[filterId] || [],
        selectedOptions: selectedOptions[filterId] || [],
        status: filterStatus[filterId] || 'default',
        groupSelectedItems: groupSelectedItems
      }, filterId);
    }), hasHiddenFilters && (isMpacWebCoherenceEnabled ? /*#__PURE__*/_jsx(Pressable, {
      xcss: buttonStyles,
      onClick: onShowAllFilters,
      children: "Show more filters"
    }) : /*#__PURE__*/_jsx(Button, {
      appearance: "subtle",
      onClick: onShowAllFilters,
      children: "Show more filters"
    })), hasSelectedFilters && (isMpacWebCoherenceEnabled ? /*#__PURE__*/_jsx(Pressable, {
      xcss: [buttonStyles, clearFiltersButtonTextStyles],
      onClick: handleClearAllFilters,
      children: "Clear filters"
    }) : /*#__PURE__*/_jsx(Button, {
      appearance: "subtle",
      onClick: handleClearAllFilters,
      children: /*#__PURE__*/_jsx(Box, {
        as: "span",
        xcss: clearFiltersButtonTextStyles,
        children: "Clear filters"
      })
    }))]
  });
};